import React from 'react';
import { TableColumn } from 'react-data-table-component';
import { Link } from 'react-router-dom';
import DataGrid from '../../Components/DataGrid/DataGrid';
import { loadFromLocalStorage } from '../../Common/Validation/LocalStorage';
import Form433AReviewService from '../../Services/Form433AReviewService';
import { IForm433AReviewListState, IForm433AUser } from './interface';
import './Form433AReview.css';

class Form433AReviewList extends React.Component<{}, IForm433AReviewListState> {

    constructor(props_: {}) {
        super(props_);

        this.state = {
            accessToken: '',
            currentPage: 1,
            currentRowsPerPage: 10,
            searchText: '',
            totalRows: 0,
            users: [],
            currentSortColumn: '',
            sortingDirection: ''
        }
    }

    private columns: TableColumn<IForm433AUser>[] = [
        {
            name: 'Taxpayer Name',
            selector: (row: IForm433AUser) => row.userName,
            sortable: true,
        },
        {
            name: 'Email',
            selector: (row: IForm433AUser) => row.email,
            sortable: true,
        },
        {
            name: 'Mobile Number',
            selector: (row: IForm433AUser) => row.mobileNumber,
            sortable: true,
        },
        {
            name: 'Status',
            selector: (row: IForm433AUser) => row.applicationStatus,
            sortable: true,
        },
        {
            name: 'Review Status',
            selector: (row: IForm433AUser) => row.isReviewed ? 'Completed' : 'Pending'
        },
        {
            name: 'Action',
            cell: (row: IForm433AUser) => (
                <Link className='f433-grid-btn' to={this.getReviewUrl(row)}>Review</Link>
            ),
            button: true,
            width: '120px'
        },
    ];

    async componentDidMount() {
        const accesstoken = await loadFromLocalStorage('accessToken');
        if (accesstoken) {
            this.setState({
                accessToken: accesstoken.toString()
            }, () => {
                this.getUsers();
            });
        }
        else {
            localStorage.clear();
            window.location.href = '/';
        }
    }

    private getUsers() {
        const sort: any = {};
        if (this.state.currentSortColumn !== '') {
            sort['column'] = this.state.currentSortColumn;
            sort['direction'] = this.state.sortingDirection;
        }
        const postData = {
            offset: (this.state.currentPage - 1) * this.state.currentRowsPerPage,
            limit: this.state.currentRowsPerPage,
            sort: sort,
            searchFilter: this.state.searchText
        };

        Form433AReviewService.getUsers(postData, this.state.accessToken).then(r => {
            if (r.ok) {
                r.json().then(resp => {
                    this.setState({
                        users: resp.data || [],
                        totalRows: resp.totalCount || 0
                    });
                });
            }
        });
    }

    private getReviewUrl(row: IForm433AUser) {
        const params = new URLSearchParams({ userId: row.userId, status: row.applicationStatus || '', isReviewed: row.isReviewed ? 'true' : 'false' });
        return `/form433AReview/details?${params.toString()}`;
    }

    private identifySortingMapColumn(columnName: string) {
        switch (columnName) {
            case 'Taxpayer Name': return 'userName';
            case 'Email': return 'email';
            case 'Mobile Number': return 'mobileNumber';
            case 'Status': return 'applicationStatus';
            default: return '';
        }
    }

    public render() {
        return (
            <div className='body-sub-contianer table-container'>
                <DataGrid
                    title='Form 433-A Review'
                    search='Users'
                    columns={this.columns}
                    data={this.state.users}
                    onSearch={(searchText_: string) => {
                        this.setState({ searchText: searchText_, currentPage: 1 }, () => this.getUsers());
                    }}
                    onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                        this.setState({ currentPage: currentPage, currentRowsPerPage: currentRowsPerPage }, () => this.getUsers());
                    }}
                    onChangePage={(page: number) => {
                        this.setState({ currentPage: page }, () => this.getUsers());
                    }}
                    onSort={(column: any, direction) => {
                        this.setState({
                            currentSortColumn: this.identifySortingMapColumn(column.name),
                            sortingDirection: direction,
                            currentPage: 1
                        }, () => this.getUsers());
                    }}
                    pagination
                    paginationTotalRows={this.state.totalRows}
                />
            </div>
        );
    }
}

export default Form433AReviewList;
